var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15,
  stroke: "#7C8087",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7C8087",
  fillRule: "evenodd",
  d: "M15 19v-1c0-.583.284-1.022.782-1.493a9 9 0 0 1 .537-.461c-.153.124.414-.334.54-.44C17.663 14.939 18 14.47 18 14c0-1.253-.84-2-2-2s-2 .747-2 2h-2c0-2.414 1.785-4 4-4s4 1.586 4 4c0 1.24-.637 2.124-1.86 3.143-.136.113-.69.56-.576.468-.185.15-.309.256-.409.35q-.105.1-.155.163V19zm1 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})));
export default SvgQuestion;